import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { map, timer } from 'rxjs';
import { AppointmentService } from 'src/app/private/services/appointment.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TimerService } from 'src/app/utils/timer.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimelineEvent } from '../clinical-timeline/clinical-timeline.component';
import { UploadService } from 'src/app/private/services/upload.service';
import { CpoeService } from 'src/app/private/services/cpoe.service';
import { ToastrService } from 'ngx-toastr';
import { MedicationsComponent } from '../medications/medications.component';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-emr-detail',
  templateUrl: './opd-dashboard.component.html',
  styleUrls: ['./opd-dashboard.component.scss']
})
export class OpdDashboardComponent {
  @ViewChild('hiddenMedicationsComp') hiddenMedicationsComp!: MedicationsComponent;
  
   startDate = new Date();
   timer:any;
   active = "patient_details"
   patient_id = 0;
   pId:any;
   current_app_id = 0;
   currentAppointment:any;
   currentDashabord:any;
   patient: Patient = new Patient();
   modules:any = [];
   permissions:any = [];
   loading: boolean = true;
   
   vitals: Vitals = new Vitals();
   vitalsHistory: any[] = [];
   activeTrendMetric: string = 'bp';
   vitalsChartInstance: any = null;
   activeHistoryTab: string = 'trend';
   encounter: Encounter = new Encounter();
   soapNote: SoapNote = new SoapNote();
   medications: Medication[] = [];
   newMedication: Medication = new Medication();

   savingVitals: boolean = false;
   savingEncounter: boolean = false;
   savingSoapNote: boolean = false;
   savingMedication: boolean = false;
 
   loadingVitals: boolean = false;
   loadingEncounter: boolean = false;
   loadingJourney: boolean = false;
   loadingMeds: boolean = false;
   loadingSoap: boolean = false;
   uploadingAvatar: boolean = false;
   modalMedications: Medication[] = [];

   followUpDate: string = "";
   followUpTime: string = "";
   journeyEvents: TimelineEvent[] = [];

   // ─── CPOE Quick Orders State ────────────────────────────────────────
   labOrders: any[] = [];
   imagingOrders: any[] = [];
   medicationOrders: any[] = [];
   cpoeLoading: boolean = false;
   cpoeSubmitting: boolean = false;
   newLabOrder: any = { test_name: '', priority: 'Routine', notes: '' };
   newImagingOrder: any = { study_name: '', clinical_indication: '', priority: 'Routine', notes: '' };
   newCpoeMedication: any = { name: '', strength: '', dose: '', route: 'PO', frequency: 'OD', duration: '', instructions: '' };
   labSubmitted: boolean = false;
   imagingSubmitted: boolean = false;
   medicationSubmitted: boolean = false;
   editingLabOrder: any = null;
   editingImagingOrder: any = null;
   // ────────────────────────────────────────────────────────────────────

   soapTemplates = [
     {
       name: 'General Checkup',
       subjective: 'Patient presents for a routine general checkup. No acute complaints.',
       objective: 'Patient appears well-nourished and in no acute distress. Vitals are stable.',
       assessment: 'Healthy individual, routine checkup.',
       plan: 'Continue current diet and exercise. Return in 1 year for annual exam.'
     },
     {
       name: 'Follow-up Visit',
       subjective: 'Patient returns for follow-up of previous condition. Reports feeling better.',
       objective: 'Vitals stable. Previous symptoms have resolved or improved.',
       assessment: 'Condition improving. Responding well to current treatment.',
       plan: 'Continue current medication. Follow up in 3 months.'
     },
     {
       name: 'Cold/Flu Symptoms',
       subjective: 'Patient reports fever, chills, cough, and body aches for the past 3 days.',
       objective: 'Elevated temperature. Mild throat erythema. Lungs clear to auscultation.',
       assessment: 'Viral upper respiratory infection / suspected flu.',
       plan: 'Rest, hydration, over-the-counter antipyretics. Return if symptoms worsen after 5 days.'
     }
   ];

   constructor(
      public timerService: TimerService,
      public route: ActivatedRoute,
      private api: AppointmentService,
      private localstorage: LocalStorageService,
      private modalService: NgbModal,
      private uploadService: UploadService,
      private toast: ToastrService,
      private cpoeService: CpoeService
    ) {
    this.permissions = JSON.parse(this.localstorage.getPermissions());   
    this.modules =  JSON.parse(JSON.stringify(this.localstorage.getFeatureModules()));
   }
   ngOnInit(){
    
      this.route.params.subscribe(params =>
          {
            this.currentDashabord = this.route.snapshot.data['dashabord'] || "";
            //console.log(this.currentDashabord)
            this.patient_id = params['id']
            this.current_app_id = params['app_id']
          })
        
          let param = {
            where:{
                  id:this.patient_id,
                  app_id:this.current_app_id,
                  hospital_id:this.localstorage.getHospitalId(),
                  center_id:this.localstorage.getCenterId(),
            }
          }
          this.api.getPatient(param).subscribe({
            next:(res)=>{
              this.loading = false;
              if(res)
              {
                this.patient = res;
                this.pId = res.pId
                localStorage.setItem('pId', res.pId);
                this.currentAppointment = res;
                if(res.advanceDeposit) {
                  if(res.advanceDeposit.amount) {
                    localStorage.setItem('advanceDeposit', res.advanceDeposit.amount);
                  }
                }
                
                // Fetch Journey History
                this.loadPatientJourney();
                this.loadEncounter();
                this.loadVitals();
                this.loadMedications();
                this.loadSoapNote();
                this.loadCpoeHistory('medications');
              }
        
            },
            error:(e)=>{
              this.loading = false;
            }
          })
         
  }

  getfeatureAccess(module_name:any,feature_name:any)
  {

    return true;
    //console.log(this.permissions)
    let feature  = [];
    let module = [];
    module = this.permissions.filter((item:any)=>{
    return  item.module_name  == module_name;
   })
  if(module.length > 0)
  {
    feature = module[0]['features'].filter((item:any)=>{
      return  item.name  == feature_name;
     })
  }
  
   return (module[0] && feature[0] ) ? true : false;

  } 
  getFeatureModuleAccess(module_name:any)
  {
    return true;

    return (this.modules.includes(module_name) ? true : false);
   }

  openModal(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }

  saveVitals(modal: any) {
    this.savingVitals = true;
    const payload = {
      ...this.vitals,
      patient_id: this.patient_id,
      app_id: this.current_app_id
    };
    this.api.saveVitals(payload).subscribe({
      next: (res) => {
        this.savingVitals = false;
        modal.close();
        this.loadPatientJourney();
        this.loadVitals();
      },
      error: (err) => {
        console.error('Error saving vitals', err);
        this.savingVitals = false;
        modal.close();
      }
    });
  }

  loadPatientJourney() {
    this.loadingJourney = true;
    this.api.getPatientJourney({ patient_id: this.patient_id }).subscribe({
      next: (historyRes) => {
        this.journeyEvents = (historyRes || []).map((item: any) => ({
          ...item,
          date: item.createdAt || item.date
        }));
        this.loadingJourney = false;
      },
      error: (e) => {
        this.journeyEvents = [];
        this.loadingJourney = false;
      }
    });
  }

  loadEncounter() {
    this.loadingEncounter = true;
    this.api.getEncounter({ patient_id: this.patient_id }).subscribe({
      next: (encounterRes) => {
        if (encounterRes) {
          this.encounter.reason = encounterRes.reason_for_visit || "";
          this.encounter.complaints = encounterRes.chief_complaints || "";
        }
        this.loadingEncounter = false;
      },
      error: (e) => {
        console.error("Error loading encounter:", e);
        this.loadingEncounter = false;
      }
    });
  }

  loadVitals() {
    this.loadingVitals = true;
    this.api.getVitals({ patient_id: this.patient_id }).subscribe({
      next: (vitalsRes) => {
        if (vitalsRes) {
          if (Array.isArray(vitalsRes)) {
            this.vitals = vitalsRes[0] || new Vitals();
            this.vitalsHistory = vitalsRes;
          } else if (vitalsRes.history) {
            this.vitals = vitalsRes.latest || new Vitals();
            this.vitalsHistory = vitalsRes.history || [];
          } else {
            this.vitals = vitalsRes;
            this.vitalsHistory = [vitalsRes];
          }
        } else {
          this.vitals = new Vitals();
          this.vitalsHistory = [];
        }
        this.loadingVitals = false;
      },
      error: (e) => {
        console.error("Error loading vitals:", e);
        this.loadingVitals = false;
      }
    });
  }

  getVitalStatus(type: string, value: any): 'normal' | 'warning' | 'danger' | 'neutral' {
    if (value === undefined || value === null || value === '' || value === '-') {
      return 'neutral';
    }

    const valStr = String(value).trim();
    if (!valStr) return 'neutral';

    switch (type) {
      case 'bp': {
        const parts = valStr.split('/');
        if (parts.length !== 2) return 'neutral';
        const sys = parseInt(parts[0], 10);
        const dia = parseInt(parts[1], 10);
        if (isNaN(sys) || isNaN(dia)) return 'neutral';
        
        if (sys >= 140 || dia >= 90) return 'danger';
        if (sys < 90 || dia < 60) return 'danger';
        if (sys > 120 || dia > 80) return 'warning';
        return 'normal';
      }
      case 'hr': {
        const hr = parseInt(valStr, 10);
        if (isNaN(hr)) return 'neutral';
        if (hr < 50 || hr > 120) return 'danger';
        if ((hr >= 50 && hr < 60) || (hr > 100 && hr <= 120)) return 'warning';
        return 'normal';
      }
      case 'temp': {
        const temp = parseFloat(valStr);
        if (isNaN(temp)) return 'neutral';
        if (temp > 101.0 || temp < 95.0) return 'danger';
        if ((temp >= 99.1 && temp <= 101.0) || (temp >= 95.0 && temp < 97.0)) return 'warning';
        return 'normal';
      }
      case 'bmi': {
        const bmi = parseFloat(valStr);
        if (isNaN(bmi)) return 'neutral';
        if (bmi >= 30.0 || bmi < 16.0) return 'danger';
        if ((bmi >= 25.0 && bmi < 30.0) || (bmi >= 16.0 && bmi < 18.5)) return 'warning';
        return 'normal';
      }
      case 'weight': {
        if (this.vitals && this.vitals.bmi) {
          return this.getVitalStatus('bmi', this.vitals.bmi);
        }
        return 'neutral';
      }
      default:
        return 'neutral';
    }
  }

  getVitalClass(type: string, value: any): string {
    const status = this.getVitalStatus(type, value);
    return `vital-item text-center vital-${status}`;
  }

  openVitalsHistoryModal(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
    setTimeout(() => {
      this.initVitalsChart();
    }, 150);
  }

  changeTrendMetric(metric: string) {
    this.activeTrendMetric = metric;
    this.initVitalsChart();
  }

  setHistoryTab(tab: string) {
    this.activeHistoryTab = tab;
    if (tab === 'trend') {
      setTimeout(() => {
        this.initVitalsChart();
      }, 50);
    }
  }

  initVitalsChart() {
    const canvas = document.getElementById('vitalsHistoryChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.vitalsChartInstance) {
      this.vitalsChartInstance.destroy();
      this.vitalsChartInstance = null;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const chronologicalHistory = [...this.vitalsHistory].reverse();
    const validEntries = chronologicalHistory.filter(item => {
      const val = item[this.activeTrendMetric];
      return val !== undefined && val !== null && String(val).trim() !== '' && String(val).trim() !== '-';
    });

    const labels = validEntries.map(item => {
      const date = new Date(item.createdAt);
      return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: '2-digit' }) + ' ' + 
             date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
    });

    let data: number[] = [];
    let label = '';
    let borderColor = '#1b6281';
    let backgroundColor = 'rgba(27, 98, 129, 0.1)';

    if (this.activeTrendMetric === 'bp') {
      const sysData = validEntries.map(item => {
        const parts = String(item.bp).split('/');
        return parseInt(parts[0], 10) || 0;
      });
      const diaData = validEntries.map(item => {
        const parts = String(item.bp).split('/');
        return parseInt(parts[1], 10) || 0;
      });

      this.vitalsChartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels,
          datasets: [
            {
              label: 'Systolic mmHg',
              data: sysData,
              borderColor: '#ef4444',
              backgroundColor: 'rgba(239, 68, 68, 0.08)',
              borderWidth: 3,
              tension: 0.3,
              fill: true,
              pointBackgroundColor: '#ef4444',
              pointRadius: 4
            },
            {
              label: 'Diastolic mmHg',
              data: diaData,
              borderColor: '#3b82f6',
              backgroundColor: 'rgba(59, 130, 246, 0.08)',
              borderWidth: 3,
              tension: 0.3,
              fill: true,
              pointBackgroundColor: '#3b82f6',
              pointRadius: 4
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: { font: { family: 'Inter', size: 12 } }
            },
            tooltip: {
              mode: 'index',
              intersect: false,
              bodyFont: { family: 'Inter' },
              titleFont: { family: 'Inter', weight: 'bold' }
            }
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: { font: { family: 'Inter', size: 10 } }
            },
            y: {
              grid: { color: '#f1f2f6' },
              ticks: { font: { family: 'Inter', size: 10 } }
            }
          }
        }
      });
      return;
    }

    if (this.activeTrendMetric === 'hr') {
      label = 'Heart Rate (bpm)';
      borderColor = '#f59e0b';
      backgroundColor = 'rgba(245, 158, 11, 0.08)';
      data = validEntries.map(item => parseInt(item.hr, 10) || 0);
    } else if (this.activeTrendMetric === 'temp') {
      label = 'Temperature (°F)';
      borderColor = '#ef4444';
      backgroundColor = 'rgba(239, 68, 68, 0.08)';
      data = validEntries.map(item => parseFloat(item.temp) || 0);
    } else if (this.activeTrendMetric === 'weight') {
      label = 'Weight (kg)';
      borderColor = '#10b981';
      backgroundColor = 'rgba(16, 185, 129, 0.08)';
      data = validEntries.map(item => parseFloat(item.weight) || 0);
    } else if (this.activeTrendMetric === 'bmi') {
      label = 'BMI';
      borderColor = '#8b5cf6';
      backgroundColor = 'rgba(139, 92, 246, 0.08)';
      data = validEntries.map(item => parseFloat(item.bmi) || 0);
    }

    this.vitalsChartInstance = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label,
            data,
            borderColor,
            backgroundColor,
            borderWidth: 3,
            tension: 0.3,
            fill: true,
            pointBackgroundColor: borderColor,
            pointRadius: 4
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            labels: { font: { family: 'Inter', size: 12 } }
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            bodyFont: { family: 'Inter' },
            titleFont: { family: 'Inter', weight: 'bold' }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { font: { family: 'Inter', size: 10 } }
          },
          y: {
            grid: { color: '#f1f2f6' },
            ticks: { font: { family: 'Inter', size: 10 } }
          }
        }
      }
    });
  }

  saveEncounter(modal: any) {
    this.savingEncounter = true;
    const payload = {
      ...this.encounter,
      patient_id: this.patient_id,
      app_id: this.current_app_id
    };
    this.api.saveEncounter(payload).subscribe({
      next: (res) => { 
        this.savingEncounter = false;
        modal.close(); 
        this.loadPatientJourney();
      },
      error: (err) => { 
        console.error('Error saving encounter', err);
        this.savingEncounter = false;
        modal.close(); 
      }
    });
  }

  saveSoapNote() {
    this.savingSoapNote = true;
    const payload = {
      ...this.soapNote,
      patient_id: this.patient_id,
      app_id: this.current_app_id
    };
    this.api.saveSoapNote(payload).subscribe({
      next: (res) => { 
        this.savingSoapNote = false;
        alert('SOAP Note Saved!'); 
        this.loadPatientJourney();
      },
      error: (err) => { 
        console.error('Error saving SOAP note', err);
        this.savingSoapNote = false;
        alert('Error saving SOAP Note'); 
      }
    });
  }

  loadMedications() {
    this.loadingMeds = true;
    this.api.getMedications({ patient_id: this.patient_id }).subscribe({
      next: (medsRes) => {
        this.medications = medsRes || [];
        this.loadingMeds = false;
      },
      error: (e) => {
        console.error("Error loading medications:", e);
        this.loadingMeds = false;
      }
    });
  }

  loadSoapNote() {
    this.loadingSoap = true;
    this.api.getSoapNote({ patient_id: this.patient_id }).subscribe({
      next: (soapRes) => {
        if (soapRes) {
          this.soapNote.subjective = soapRes.subjective || "";
          this.soapNote.objective = soapRes.objective || "";
          this.soapNote.assessment = soapRes.assessment || "";
          this.soapNote.plan = soapRes.plan || "";
        }
        this.loadingSoap = false;
      },
      error: (e) => {
        console.error("Error loading SOAP Note:", e);
        this.loadingSoap = false;
      }
    });
  }

  openMedicationModal(content: any) {
    this.modalMedications = [new Medication()];
    this.modalService.open(content, { centered: true, size: 'md' });
  }

  addModalMedicationRow() {
    this.modalMedications.push(new Medication());
  }

  removeModalMedicationRow(index: number) {
    if (this.modalMedications.length > 1) {
      this.modalMedications.splice(index, 1);
    } else {
      this.modalMedications = [new Medication()];
    }
  }

  addMedication(modal: any) {
    const validMeds = this.modalMedications.filter(m => m.name && m.name.trim());
    if (validMeds.length > 0) {
      this.savingMedication = true;
      const payload = {
        medications: validMeds,
        patient_id: this.patient_id,
        app_id: this.current_app_id
      };
      this.api.addMedication(payload).subscribe({
        next: (res) => {
          this.savingMedication = false;
          modal.close();
          this.loadMedications();
          this.loadPatientJourney();
        },
        error: (err) => {
          this.savingMedication = false;
          console.error('Error adding medication', err);
          modal.close();
        }
      });
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Show image immediately
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.patient.photo = e.target.result;
      };
      reader.readAsDataURL(file);

      this.uploadingAvatar = true;
      const formData = new FormData();
      formData.append("file", file, this.patient.pId);
      let folder = "public/hospital-" + this.localstorage.getHospitalId() + "/" + this.patient.pId + "/profile";
      formData.append("folders", folder);
      formData.append("bucket", "emruploads");

      this.uploadService.uploadPatientProfile(formData).subscribe({
        next: (res) => {
          if (res && res.url) {
            const updateParam = {
              id: this.patient.id,
              hospital_id: (this.patient as any).hospital_id || this.localstorage.getHospitalId(),
              center_id: (this.patient as any).center_id || this.localstorage.getCenterId(),
              photo: res.url
            };
            this.api.updatePatient(updateParam).subscribe({
              next: (updateRes: any) => {
                this.uploadingAvatar = false;
                if (updateRes) {
                  this.patient.photo = res.url;
                  this.toast.success("Profile photo updated successfully!");
                }
              },
              error: (err) => {
                this.uploadingAvatar = false;
                console.error("Error updating patient photo in DB:", err);
                this.toast.error("Failed to update patient profile photo in database.");
              }
            });
          } else {
            this.uploadingAvatar = false;
            this.toast.error("Upload returned invalid response.");
          }
        },
        error: (err) => {
          this.uploadingAvatar = false;
          console.error("Error uploading profile image:", err);
          this.toast.error("Failed to upload image.");
        }
      });
    }
  }

  applyTemplate(template: any, modal: any) {
    this.soapNote.subjective = template.subjective;
    this.soapNote.objective = template.objective;
    this.soapNote.assessment = template.assessment;
    this.soapNote.plan = template.plan;
    modal.close();
  }

  bookFollowUp() {
    if(!this.followUpDate || !this.followUpTime) {
      alert("Please select both date and time");
      return;
    }
    let data = { patient_id: this.patient_id, date: this.followUpDate, time: this.followUpTime };
    this.api.createAppointment(data).subscribe({
      next: (res) => { alert('Appointment Booked!'); },
      error: (err) => { alert('Appointment Booked (Simulated)!'); }
    });
  }

  // ─── CPOE Quick Orders ───────────────────────────────────────────────

  openSidebarMedicationPopup() {
    if (this.hiddenMedicationsComp) {
      this.hiddenMedicationsComp.OpenNewMedication(this.hiddenMedicationsComp.content);
    }
  }

  openCpoeModal(content: TemplateRef<any>, type: 'labs' | 'imaging' | 'medications') {
    this.resetCpoeForms();
    this.loadCpoeHistory(type);
    this.modalService.open(content, {
      size: 'xl',
      scrollable: true,
      centered: true,
      windowClass: 'cpoe-modal emr-custom-modal',
      ariaLabelledBy: 'cpoe-modal-title'
    });
  }

  resetCpoeForms() {
    this.newLabOrder = { test_name: '', priority: 'Routine', notes: '' };
    this.newImagingOrder = { study_name: '', clinical_indication: '', priority: 'Routine', notes: '' };
    this.newCpoeMedication = { name: '', strength: '', dose: '', route: 'PO', frequency: 'OD', duration: '', instructions: '' };
    this.labSubmitted = false;
    this.imagingSubmitted = false;
    this.medicationSubmitted = false;
  }

  loadCpoeHistory(type: 'labs' | 'imaging' | 'medications') {
    const payload = {
      patient_id: this.patient_id,
      hospital_id: this.localstorage.getHospitalId()
    };
    this.cpoeLoading = true;

    if (type === 'labs') {
      this.cpoeService.getLabOrders(payload).subscribe({
        next: (res) => { this.labOrders = res || []; this.cpoeLoading = false; },
        error: () => { this.cpoeLoading = false; }
      });
    } else if (type === 'imaging') {
      this.cpoeService.getImagingOrders(payload).subscribe({
        next: (res) => { this.imagingOrders = res || []; this.cpoeLoading = false; },
        error: () => { this.cpoeLoading = false; }
      });
    } else if (type === 'medications') {
      this.cpoeService.getMedications(payload).subscribe({
        next: (res) => { this.medicationOrders = res || []; this.cpoeLoading = false; },
        error: () => { this.cpoeLoading = false; }
      });
    }
  }

  submitLabOrder() {
    this.labSubmitted = true;
    if (!this.newLabOrder.test_name) return;
    this.cpoeSubmitting = true;
    const payload = {
      patient_id: this.patient_id,
      app_id: this.current_app_id,
      opd_id: (this.currentAppointment as any)?.opd_number || null,
      hospital_id: this.localstorage.getHospitalId(),
      ...this.newLabOrder
    };
    this.cpoeService.addLabOrder(payload).subscribe({
      next: () => {
        this.toast.success('Lab order placed successfully');
        this.cpoeSubmitting = false;
        this.newLabOrder = { test_name: '', priority: 'Routine', notes: '' };
        this.labSubmitted = false;
        this.loadCpoeHistory('labs');
      },
      error: () => { this.cpoeSubmitting = false; this.toast.error('Failed to place lab order'); }
    });
  }

  editLabOrder(order: any) {
    this.editingLabOrder = { ...order };
  }

  cancelEditLabOrder() {
    this.editingLabOrder = null;
  }

  saveUpdatedLabOrder() {
    if (!this.editingLabOrder) return;
    this.cpoeSubmitting = true;
    this.cpoeService.updateLabOrder(this.editingLabOrder).subscribe({
      next: () => {
        this.toast.success('Lab order updated successfully');
        this.cpoeSubmitting = false;
        this.editingLabOrder = null;
        this.loadCpoeHistory('labs');
      },
      error: () => {
        this.cpoeSubmitting = false;
        this.toast.error('Failed to update lab order');
      }
    });
  }

  submitImagingOrder() {
    this.imagingSubmitted = true;
    if (!this.newImagingOrder.study_name) return;
    this.cpoeSubmitting = true;
    const payload = {
      patient_id: this.patient_id,
      app_id: this.current_app_id,
      opd_id: (this.currentAppointment as any)?.opd_number || null,
      hospital_id: this.localstorage.getHospitalId(),
      ...this.newImagingOrder
    };
    this.cpoeService.addImagingOrder(payload).subscribe({
      next: () => {
        this.toast.success('Imaging order placed successfully');
        this.cpoeSubmitting = false;
        this.newImagingOrder = { study_name: '', clinical_indication: '', priority: 'Routine', notes: '' };
        this.imagingSubmitted = false;
        this.loadCpoeHistory('imaging');
      },
      error: () => { this.cpoeSubmitting = false; this.toast.error('Failed to place imaging order'); }
    });
  }

  editImagingOrder(order: any) {
    this.editingImagingOrder = { ...order };
  }

  cancelEditImagingOrder() {
    this.editingImagingOrder = null;
  }

  saveUpdatedImagingOrder() {
    if (!this.editingImagingOrder) return;
    this.cpoeSubmitting = true;
    this.cpoeService.updateImagingOrder(this.editingImagingOrder).subscribe({
      next: () => {
        this.toast.success('Imaging order updated successfully');
        this.cpoeSubmitting = false;
        this.editingImagingOrder = null;
        this.loadCpoeHistory('imaging');
      },
      error: () => {
        this.cpoeSubmitting = false;
        this.toast.error('Failed to update imaging order');
      }
    });
  }

  submitMedicationOrder() {
    this.medicationSubmitted = true;
    if (!this.newCpoeMedication.name) return;
    this.cpoeSubmitting = true;
    const payload = {
      patient_id: this.patient_id,
      app_id: this.current_app_id,
      opd_id: (this.currentAppointment as any)?.opd_number || null,
      hospital_id: this.localstorage.getHospitalId(),
      name: this.newCpoeMedication.name,
      strength: this.newCpoeMedication.strength,
      dose: this.newCpoeMedication.dose,
      route: this.newCpoeMedication.route,
      frequency: this.newCpoeMedication.frequency,
      duration: this.newCpoeMedication.duration,
      instructions: this.newCpoeMedication.instructions,
      status: 'Active'
    };
    this.cpoeService.addMedication(payload).subscribe({
      next: () => {
        this.toast.success('Medication prescribed successfully');
        this.cpoeSubmitting = false;
        this.newCpoeMedication = { name: '', strength: '', dose: '', route: 'PO', frequency: 'OD', duration: '', instructions: '' };
        this.medicationSubmitted = false;
        this.loadCpoeHistory('medications');
        this.loadMedications();
      },
      error: () => { this.cpoeSubmitting = false; this.toast.error('Failed to prescribe medication'); }
    });
  }
  // ────────────────────────────────────────────────────────────────────
}




export class Patient {
   id!: Number;
   pId:string = "";
   fname: string = "";
   lname: string = "";
   prefix: string = "";
   gender: string = "";
   blood_group:string = "";
   age: Number = 0;
   email: string = "";
   mobile: string = "";
   address: string = "";
   photo: string = "";
 }

export class Vitals {
  bp: string = "";
  hr: string = "";
  temp: string = "";
  weight: string = "";
  bmi: string = "";
}

export class Encounter {
  reason: string = "";
  complaints: string = "";
}

export class SoapNote {
  subjective: string = "";
  objective: string = "";
  assessment: string = "";
  plan: string = "";
}

export class Medication {
  name: string = "";
  status: string = "Active";
  dosage: string = "";
}
